module.exports = __webpack_public_path__ + "static/media/Bumble_and_Bumble.599a1746.png";